// extracted by css-extract-rspack-plugin
export default {"solid":"tune-button-module__solid___qIvXy","outer":"tune-button-module__outer___Xdtis"};